<template>
  <div
    :class="[
      $style.base,
      {
        [$style.smallScreen]: $screen === 's',
        [$style.mediumScreen]: $screen === 'm'
      }
    ]"
  >
    <BaseAccordion
      v-model="activeKeys"
      :titles="items.map((item) => item.question)"
      mb
    >
      <template
        v-for="(item, index) in items"
        :key="item.question"
        #[index+1]
      >
        {{ item.answer }}
      </template>
    </BaseAccordion>
    <div :class="$style.moreLink">
      <BaseText
        :href="helpPage"
        v-test="'sp-faq-learn-more'"
      >
        {{ $t('global.learn_more') }}
      </BaseText>
    </div>
  </div>
</template>
<script
  lang="ts"
  setup
>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { brandName, brandNamePay } from '@/helpers/brand-name';
import { replacePinapparaat } from '@/helpers/formatting';
import { helpCenterCollectionUrl } from '@/helpers/help-center';
import { useCompanyStore } from '@/stores/company';

type FaqItem = {
  question: string;
  answer: string;
};

const props = withDefaults(
  defineProps<{
    // Swaps the questions about getting started for ones about payouts, fees and terminal issues.
    hasATerminal?: boolean;
  }>(),
  {
    hasATerminal: false,
  },
);

const { company } = useCompanyStore();
const { t } = useI18n();

const key = (name: string) =>
  `register.salonized_pay.landing.faq_section.${name}`;

const brandNames = { ...brandName(), ...brandNamePay() };

// Belgian salons say "betaalterminal" where Dutch ones say "pinapparaat".
const faqItems = (prefix: string, count: number, answerKey: string) =>
  Array.from(
    { length: count },
    (_, index): FaqItem => ({
      question: t(key(`${prefix}question_${index + 1}`), brandNames),
      answer: replacePinapparaat(
        t(key(`${answerKey}_${index + 1}`), brandNames),
        company.country,
      ),
    }),
  );

const items = computed(() =>
  props.hasATerminal
    ? faqItems('has_terminal_', 4, 'has_terminal_answer')
    : faqItems('', 7, 'asnwer'),
);

const activeKeys = ref([]);

const helpPage = helpCenterCollectionUrl('/collections/6856279-salonized-pay');
</script>

<style
  lang="scss"
  module
>
.base {
  max-width: 950px;
  width: 100%;
}

.moreLink {
  display: flex;
  justify-content: center;
  padding: $spacing;
}
</style>
